import { connect } from 'react-redux'

import Component from './NotFound'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({

})

export default connect(mapStateToProps, mapActionCreators)(Component)



// WEBPACK FOOTER //
// ./src/containers/404/index.js